<template>
        <div class="modal-backdrop z-50 w-full scrolling-touch" @click.self="outsideClose">
            <div class="modal z-50" :class='`${classes}`'>
            <img v-if="showCloseButton"
                 alt="cross-partner"
                 src="../../assets/SVG/cross-partners.svg"
                 class="absolute text-white pin-t pin-r mr-4 mt-4 cursor-pointer text-xl z-50 h-4"
                 @click="close">
                        <slot></slot>
            </div>
        </div>
</template>

<script>
import isMobile from '../../mixins/isMobile';
import Modals from '../../mixins/modals';

export default {
  name: 'modal',
  mixins: [isMobile, Modals],
  props: {
    classes: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isPhone() {
      return this.isMobile;
    },
  },
  methods: {
    outsideClose() {
      if (this.click_outside === true) this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
  },

};
</script>

<style scoped>

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.5);
        display: grid;
        place-content: center;
    }

    .modal {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        padding-top:2rem ;
    }

    .modal {
        border-radius: 0.85rem;
        -webkit-box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
        box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
    }

    .long {
        padding-top: 20px !important;
        @apply rounded-lg;
        margin-top: 700px  !important;
        margin-bottom: 70px !important;
    }
</style>
